{
  "version": 1,
  "asset_id": "3834de10-a536-47ce-82f6-948ee0826315",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/3834de10-a536-47ce-82f6-948ee0826315/case-bowlscoreboard-avatar.jpg",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/3834de10-a536-47ce-82f6-948ee0826315/case-bowlscoreboard-avatar.jpg",
  "original_filename": "case-bowlscoreboard-avatar.jpg",
  "size": 20379,
  "content_type": "image/jpeg",
  "created_at": "2026-08-21T16:59:56Z"
}
